import {Typography} from "@mui/material";
import React from "react";

export default function ListGameItem({name}: { name: string }) {
    return <Typography>{name}</Typography>
}